import React, { useState } from "react";
import { toast } from "react-toastify";
import { format } from "date-fns";
import ClearIcon from "@mui/icons-material/Clear";
import chip from "../../../assets/chip.png";
import contractless from "../../../assets/contractless.png";

const CardForm = ({
  value,
  totalPrice,
  setIsComplete,
  setValue,
  toggleRun,
  setIsShippingAddressFullfil,
  setIsProceedToPay,
}) => {
  const [bankName, setBankName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cardHolder, setCardHolder] = useState("");
  const [isRotate, setIsRotate] = useState(false);
  const [cardExpire, setCardExpire] = useState("");
  const [cvv, setCvv] = useState("");
  const toastStyle = {
    position: "top-center",
    autoClose: 2000,
  };

  const rotate = () => {
    setIsRotate(!isRotate);
  };

  const BankNameOnChange = (e) => {
    const BankName = e.target.value;
    // console.log(isNaN(BankName));
    const regex = /^[A-Za-z]+$/;
    if (regex.test(BankName)) {
      setBankName(BankName);
    } else if (BankName === "") {
      setBankName("");
    } else {
      toast.warn(
        "Can't use number or special characters or empty string!",
        toastStyle
      );
    }
  };
  const cardNumberOnChange = (event) => {
    const inputCardNumber = event.target.value;
    let formattedValue = "XXXX XXXX XXXX XXXX";

    if (!isNaN(inputCardNumber)) {
      for (let i = 0; i < inputCardNumber.length; i++) {
        formattedValue = formattedValue.replace("X", inputCardNumber[i]);
      }
      setCardNumber(formattedValue);
    } else {
      toast.warn("Can't type text! Input values must be numbers", toastStyle);
    }
  };

  const OnChangeCVV = (e) => {
    const value = e.target.value;
    if (isNaN(value)) {
      toast.warn("Input values must be numbers!", toastStyle);
    } else {
      setCvv(value);
    }
  };

  const CardHolderOnChange = (e) => {
    const holderName = e.target.value;
    const regex = /^[a-zA-Z\s]+$/;
    if (regex.test(holderName)) {
      setCardHolder(holderName);
    } else if (holderName === "") {
      setCardHolder("");
    } else {
      toast.warn("Card Holder name must be proper name!", toastStyle);
    }
  };
  function isCardNumberValid(cardNumber) {
    const regex = /^(\d{4}\s){3}\d{4}$/;
    return regex.test(cardNumber);
  }
  // this is the payment bank card onSubmit function
  // console.log(bankName, typeof bankName);
  const OnSubmitPayment = (e) => {
    e.preventDefault();
    if (
      bankName !== "" &&
      cardNumber !== "" &&
      cardHolder !== "" &&
      cardExpire !== "" &&
      cvv !== ""
    ) {
      if (cardNumber.length === 19 && isCardNumberValid(cardNumber)) {
        setIsShippingAddressFullfil(false);
        setIsProceedToPay(false);
        setIsComplete("completed");
        toggleRun(true);
        toast.success(`Payment successfully done by ${cardHolder}!`, {
          position: "top-center",
          autoClose: 1500,
        });
        // console.log(cardNumber.length);
      } else {
        // console.log(cardNumber.length);
        toast.warn(
          "Bank Card number must be 16 digit and contains only nubmers!",
          toastStyle
        );
      }
    } else {
      toast.warn("Please fill all the inputs and try again!", toastStyle);
    }
  };
  return (
    <section
      className={`section_custom_form_container ${
        value !== "" && "show-section_custom_form_container"
      }`}
    >
      <article className="bal-card dynamic-card-container">
        <button onClick={() => setValue("")} className="payment-cross-btn">
          <ClearIcon sx={{ fontSize: "30px" }} />
        </button>
        <div onClick={rotate} className="card-display-details">
          <div
            className={`${isRotate && "rotate"}`}
            style={{ overflow: "hidden" }}
          >
            <div className=" card_original_structure">
              <h1 className="bank-name-shadow">{bankName || "boc"}</h1>
              <h1 className="bank-name-shadow font-extrabold">{value} card</h1>
            </div>
            <img src={chip} alt="" className="  chip_class" />
            <h1 className=" card-numberX">
              {cardNumber || "XXXX XXXX XXXX XXXX"}
            </h1>
            <h5 className="card-holder-name">{cardHolder || "card holder"}</h5>
            <div className="bal-sal-date">
              <p className="">Month/year</p>
              <div>
                <p className="text-[7px] card-exp mr-2">Exp:</p>
                <p className="date-exp-p">
                  {format(new Date(cardExpire || null), "MM/yy")}
                </p>
              </div>
            </div>
          </div>
          <div className={`${!isRotate ? "showCvc" : ""}`}>
            <p className=" webiste_links_bnk">
              https://www.{bankName.toLowerCase()}.com
            </p>
            <h1 className=" cvv-black-cvv-white" style={{ width: "100%" }}></h1>
            <img
              src={contractless}
              alt=""
              className="cvv-single contactless_icon"
            />
            <h1 className=" cvv-black-cvv-white cvv-single cvv_bg">
              {cvv || "XXX"}
            </h1>
            <p className=" authorized-sig-small">Authorized Signature</p>
            <ul className=" ul-bank-card-regulation regulation-card">
              <li>
                The use of this card, you must comply with the {value} Card
                Regulation of {bankName.toUpperCase()}.
              </li>
              <li>
                If the cardholder loses this card, please report the loss to our
                bank as soon as possible.
              </li>
            </ul>
          </div>
        </div>
        <section className="my-auto md:mr-10 bal-form">
          <h1 className="bank-name-shadow-s">Your Payment Details</h1>
          <h1 className="form-amount-details">Amount: ${totalPrice}</h1>
          <form
            onSubmit={OnSubmitPayment}
            className="form-card"
            style={{ width: "100%", maxWidth: "300px" }}
          >
            <label htmlFor="bankShortName">Bank Short Name</label>
            <input
              type="text"
              name="bankShortName"
              placeholder="e.g. BOC"
              id="bankShortName"
              onChange={BankNameOnChange}
              maxLength={6}
              autoComplete="off"
            />
            <label htmlFor="cardHolderName">Card Holder Name</label>
            <input
              type="text"
              placeholder="example@Jhon Deo"
              id="cardHolderName"
              autoComplete="off"
              onChange={CardHolderOnChange}
            />
            <label htmlFor="cardNumberInput">Credit Card Number</label>
            <input
              id="cardNumberInput"
              type="text"
              placeholder="1234 4567 2121 4465"
              onChange={cardNumberOnChange}
              maxLength={16}
              autoComplete="off"
              // value={cardNumber}
              pattern="[0-9\s]{13,19}"
            />
            <div className="flex justify-between class_flex_date_exp_cvv">
              <div className="">
                <label htmlFor="expireDate">Exp Date</label>
                <input
                  type="month"
                  onChange={(e) => setCardExpire(e.target.value)}
                  id="expireDate"
                  className="cvv_input"
                />
              </div>
              <div className="">
                <label htmlFor="cvv">cvc/Cvv</label>
                <input
                  type="text"
                  placeholder="XXX"
                  id="cvv"
                  autoComplete="off"
                  maxLength={6}
                  onChange={OnChangeCVV}
                  onMouseEnter={() => setIsRotate(true)}
                  onMouseLeave={() => setIsRotate(false)}
                  className="cvv_input"
                />
              </div>
            </div>
            <button type="submit" className="form-pay-btn">
              Pay Now
            </button>
          </form>
        </section>
      </article>
    </section>
  );
};

export default CardForm;
